<template>
  <video-background 
        :src="backgroundVideo"
        style="height: 100vh;"
        :poster="poster"
     >
    <slot></slot>
  </video-background>
</template>

<style type="text/css" scoped>
   
</style>

<script>
  /**
   * @see https://github.com/avidofood/vue-responsive-video-background-player
   */

  import VideoBackground from 'vue-responsive-video-background-player'

  const folder = 'https://zwan-spaces.fra1.cdn.digitaloceanspaces.com/'

  export default {
    name: 'VideoBg',

    components:
    {
      VideoBackground
    },

    mixins: [],

    data: () => ({
      
    }),

    props: {
      filename: {
        type: String,
        default: 'bg2'
      }
    },

    computed: 
    {
      backgroundVideo()
      {
        return `${folder}${this.filename}.mp4`
      },
      poster()
      {
        return `${folder}${this.filename}.jpg`
      }
    },

    methods:
    {
      
    }
  }
</script>
